import omit from 'lodash/omit'

import { SEPAMatchDataType, SupplementMatchDataType } from './worksheet'

const sanitizeEmployeeMatchedData = (
  matchedData: SEPAMatchDataType[] | SupplementMatchDataType[]
) => {
  const sanitized = [...matchedData].map((match) => {
    const cleaned = omit(match, ['amount', 'IBAN', 'userId'])
    cleaned.name === cleaned.last_name
      ? (cleaned.full_name = cleaned.name)
      : (cleaned.first_name = cleaned.name)

    if (cleaned.name === cleaned.last_name) {
      return omit(cleaned, ['name', 'last_name'])
    } else {
      return omit(cleaned, 'name')
    }
  })

  return sanitized
}

export default sanitizeEmployeeMatchedData
